<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        :id="id"
        color="primary"
        class="white--text ma-2"
        v-on="on"
      >
        Export
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in exportOptions"
        :key="index"
        @click="item.callback"
      >
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'ExportButton',

    props: {
      id: String,
    },

    data () {
      return {
        exportOptions: [
          { text: 'CSV', callback: () => this.$emit('clickCsv') },
          { text: 'XLS', callback: () => this.$emit('clickXls') },
        ],
      }
    },
  }
</script>
